import { useEffect } from "react";
import { useLangStore } from "./i18n/store";
import { Navbar } from "./components/Navbar";
import { PreviewCanvas } from "./components/PreviewCanvas";
import { PropertiesPanel } from "./components/PropertiesPanel";
import { BusyOverlay } from "./components/BusyOverlay";

export const App = () => {
  const lang = useLangStore((s) => s.lang);
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <div className="app">
      <Navbar />
      <div className="workspace">
        <PreviewCanvas />
        <PropertiesPanel />
      </div>
      <BusyOverlay />
    </div>
  );
};
